import React, { useState } from 'react'
import { ArrowLeftIcon, ArrowRightIcon, XCircleIcon } from '@heroicons/react/outline'

export default function Step7({ nextStep, prevStep, updateFieldValue, value }) {

    const [selected, setSelected] = useState(value)
    const [error, showError] = useState(false)

    const handleNextStep = () => {
        if (selected === "") {
            showError(true)
        } else {
            updateFieldValue("enrollmentPlan", selected);
            nextStep(7)
        }
    }

    const handleForward = (v) => {
        setSelected(v)
        updateFieldValue("enrollmentPlan", v);
        nextStep(7)
    }

    return (
        <div id="step7" >
            <div className='max-w-lg mx-auto p-10'>
                <fieldset>
                    <legend className='font-normal text-base px-6'>Are you currently enrolled in a payment installment agreement?</legend>
                    <div className='mt-5 ml-2 text-base text-gray-800'>
                        <div className='py-1'>
                            <input type="radio" id="enrollmentPlan-yes" defaultChecked={value === "Yes"} onClick={() => handleForward("Yes")} name="are_you_currently_enrolled_in_a_payment_installment_agreement_" value="yes" />
                            <label htmlFor="enrollmentPlan-yes" className='ml-2'>Yes</label></div>

                        <div className='py-1'>
                            <input type="radio" id="enrollmentPlan-no" defaultChecked={value === "No"} onClick={() => handleForward("No")} name="are_you_currently_enrolled_in_a_payment_installment_agreement_" value="no" />
                            <label htmlFor="enrollmentPlan-no" className='ml-2'>No</label></div>
                    </div>
                </fieldset>
                {
                    error &&
                    <p className="mt-2 mb-0 text-xs text-red-500 flex">
                        <XCircleIcon className="h-4 w-4 mr-1" /> Please select a value.
                    </p>
                }
            </div>
            <div className="relative flex items-center justify-between w-full h-14 bg-blue-600 rounded-b-md">
                <button
                    id="calcStep7Prev"
                    onClick={() => prevStep(7)}
                    className="flex items-center h-full w-fit rounded-bl-md hover:bg-blue-800 text-white text-base px-5 py-1.5 font-semibold uppercase">
                    <ArrowLeftIcon className='h-5 w-5 mr-2' /> <span className="hidden md:block">Prev</span>
                </button>

                {/* Centered Step Counter */}
                <div className="absolute left-1/2 -translate-x-1/2 text-white opacity-50">
                    7 of 12
                </div>

                {/* Next Button */}
                <button
                    id="calcStep7Next"
                    onClick={() => handleNextStep()}
                    className="flex items-center h-full px-5 font-semibold text-white uppercase bg-blue-600 rounded-br-md hover:bg-blue-800"
                >
                    <span className="hidden md:block">Next</span>
                    <ArrowRightIcon className="w-5 h-5 ml-2" />
                </button>
            </div>

        </div>
    );
}